import { useState } from "react";
import { faqs } from "@/mocks/resources";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[360px_1fr] gap-8 md:gap-12">
          <div>
            <SectionHeading
              eyebrow="常见问题"
              icon="ri-question-line"
              title="关于色虎资源的常见疑问"
              desc="这里整理了关于内容类型、分类方式与浏览体验的常见问题。点击问题即可展开查看详细说明。"
            />
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => {
              const isOpen = open === index;
              return (
                <div
                  key={faq.q}
                  className="rounded-lg bg-background-50 border border-background-200 overflow-hidden"
                >
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpen(isOpen ? null : index)}
                    className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                  >
                    <span className="font-heading text-base font-bold text-foreground-950">
                      {faq.q}
                    </span>
                    <i
                      className={`shrink-0 text-xl text-primary-600 transition-transform ${
                        isOpen ? "ri-subtract-line" : "ri-add-line"
                      }`}
                    ></i>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5">
                      <p className="text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}